import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams, PopoverController } from '@ionic/angular';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AccountService } from 'src/app/services/account.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss'],
})
export class AccountListComponent implements OnInit {
  @Input('userAccounts') userAccounts: any;
  currentAccount: any;
  isEmirati: any;
  constructor(
    private navParams: NavParams,
    private POC: PopoverController,
    private SS: SubjectService,
    private modalController: ModalController,
    private cdr: ChangeDetectorRef,
    private AS: AccountService,
    private router: Router,
    private UTS: UtilitiesService
  ) {
    // this.userAccounts = this.navParams.get('userAccounts');
  }

  ngOnInit() { }

  selectAccount(ua: any) {
    localStorage.removeItem('subCategoryId');
    localStorage.removeItem('switchAccount');
    localStorage.removeItem('currentAccount');
    localStorage.setItem('switchAccount', 'true');
    localStorage.setItem('mobileAccount', 'true');
    localStorage.setItem('currentAccount', JSON.stringify(ua));
    this.selectedAccount(ua);
    this.modalController.dismiss(ua);
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  selectedAccount(r) {
    if (r) {
      this.currentAccount = r;
      this.SS.currentAccount.next(this.currentAccount);
      this.cdr.detectChanges();
      if (this.currentAccount.planCategory) {
        // this.AS.getAccountType(this.currentAccount.accountNo).subscribe(
        //   (response: any) => {
        //     if (response && response.emirati) {
        //       this.isEmirati = response.emirati;
        //     }
        this.AS.getCategoryInfo({
          categoryName: this.currentAccount.planCategory,
          isEmirati: this.isEmirati,
        }).subscribe((response: any) => {
          if (response && response.categoryId) {
            this.router.navigateByUrl(
              '/addons?subCategory=' +
              response.categoryId +
              '&lang=' +
              this.UTS.getLocaleLanguage()
            );
            return false;
          }
          // });
        }
        );
      } else if (this.currentAccount.serviceAccountType && this.currentAccount.serviceAccountType.toLocaleLowerCase() == 'elife') {
        this.router.navigateByUrl(
          '/addons?subCategory=' +
          AppSettings.E_LIFE +
          '&lang=' +
          this.UTS.getLocaleLanguage()
        );
      }
      else {
        this.AS.getAccountType(this.currentAccount.accountNo).subscribe(
          (response: any) => {
            if (response && response.emirati) {
              this.isEmirati = response.emirati;
            }
            let id = AppSettings.POSTPAID;
            if (this.currentAccount.accountType) {
              if (this.currentAccount.accountType.toLowerCase() == 'prepaid')
                id = AppSettings.PREPAID;
              if (this.currentAccount.accountType.toLowerCase() == 'postpaid')
                id = AppSettings.POSTPAID;
              if (
                this.currentAccount.accountType.toLowerCase() == 'visitorline'
              )
                id = AppSettings.VISITOR_LINE;
              if (
                this.currentAccount.accountType.toLowerCase() == 'controlline'
              )
                id = AppSettings.CONTROL_LINE;
              if (this.currentAccount.serviceAccountType && this.currentAccount.serviceAccountType.toLowerCase() == 'elife')
                id = AppSettings.E_LIFE;
            }
            this.AS.getCategoryInfo({
              categoryName: id,
              isEmirati: this.isEmirati,
            }).subscribe((response: any) => {
              if (response && response.categoryId) {
                this.router.navigateByUrl(
                  '/addons?subCategory=' +
                  response.categoryId +
                  '&lang=' +
                  this.UTS.getLocaleLanguage()
                );
                return false;
              }
            });
          }
        );
      }
    }
  }
}
